import TableSortHeader from 'components/table/TableSortHeader';
import { AccountTypeConstant, AccountTypeNameConstant, RoleTypeNameConstant } from 'constants/code.constant';
import { format } from 'date-fns';
import useAccount from 'hooks/useAccount';
import useSortTable from 'hooks/useSortTable';
import MainLayout from 'layouts/MainLayout';
import { useState } from 'react';
import Pagination from 'react-js-pagination';
import { Link } from 'react-router-dom';

const headCells = [
  { id: '', label: '#', width: '5%', isSort: false },
  { id: 'code', label: '고유코드', width: '10%', isSort: false },
  { id: 'email', label: '이메일', isSort: false },
  { id: 'name', label: '이름', width: '20%', isSort: true },
  { id: 'accounType', label: '계정 유형', width: '10%', isSort: true },
  { id: 'roleType', label: '권한', width: '10%', isSort: true },
  { id: 'createdAt', label: '등록일', width: '10%', isSort: true },
  { id: '', label: '비고', width: '10%' },
];

const AdminList = () => {
  const [page, setPage] = useState(1);
  const limit = 10;
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const { sortBy, sortOrder, handleRequestSort } = useSortTable();

  const { useGetAccountList } = useAccount();
  const {
    list: admins,
    totalCount,
    refetch,
  } = useGetAccountList({
    page,
    limit,
    sortBy,
    sortOrder,
    email,
    name,
    accountType: AccountTypeConstant.ADMIN,
  });

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    refetch();
  };

  const handlePageChange = (value) => {
    setPage(value);
  };

  return (
    <MainLayout>
      <div className="page-header">관리자 목록</div>
      <div className="page-card">
        <form>
          <div className="table-search-wrap">
            <div>
              <label>이메일</label>
              <input type="text" placeholder="이메일" maxLength={100} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label>이름</label>
              <input type="text" placeholder="이름" maxLength={100} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="btn">
              <button className="btn" onClick={handleSearch}>
                검색
              </button>
            </div>
          </div>
        </form>
      </div>
      <br />
      <Link to={'/admin/admin/detail'}>
        <button className="btn add-btn">등록</button>
      </Link>
      <br />
      <br />
      <div className="page-card">
        <div className="table-wrap">
          <p>
            조회된 수: <strong>{totalCount}</strong>개
          </p>
          <table>
            <TableSortHeader
              sortBy={sortBy}
              sortOrder={sortOrder}
              handleRequestSort={handleRequestSort}
              headCells={headCells}
            />
            <tbody>
              {totalCount === 0 && (
                <tr>
                  <td colSpan={headCells.length}>검색 결과가 없습니다.</td>
                </tr>
              )}
              {admins.map((item, index) => (
                <tr key={index}>
                  <td>{totalCount - (page - 1) * limit - index}</td>
                  <td>{item.code}</td>
                  <td>{item.email}</td>
                  <td>{item.name}</td>
                  <td>
                    {item.accountType
                      .split(', ')
                      .map((type) => AccountTypeNameConstant[type])
                      .join(', ')}
                  </td>
                  <td>{RoleTypeNameConstant[item.roleType]}</td>
                  <td>{format(item.createdAt, 'yyyy-MM-dd')}</td>
                  <td>
                    <Link to={`/admin/admin/detail?code=${item.code}`}>
                      <button className="btn edit-btn">수정</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalCount > 0 && (
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalCount}
              pageRangeDisplayed={10}
              onChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default AdminList;
